import styled from "styled-components";
import { DatePicker, TimePicker, Button } from "antd";
import Scrollbars from "react-custom-scrollbars";

export const Container = styled.div`
    width: 100%;
    background: #e7efe7;
`;

export const ModalBody = styled.div<{ onClick }>`
    padding: 20px;
    font-size: 18px;

    > div:nth-child(n + 2) {
        margin-top: 15px;
    }
`;

export const ItemBlock = styled.div`
    position: relative;
`;

export const Label = styled.div`
    padding-left: 1px;
    font-weight: 600;
    font-size: 14px;
`;

export const Input = styled.input<{ isValid: boolean }>`
    ${({ isValid }) => (isValid ? "" : "border: 1px solid red;")}
    margin-top: 8px;
    width: 100%;
    padding: 12px 17px;
    border-radius: 6px;
    outline: none;
    position: relative;
`;

export const TickerName = styled.div`
    margin-top: 8px;
    width: 100%;
    padding: 12px 17px;
    border-radius: 6px;
    background-color: #fff;
    text-align: center;
`

export const ScrollbarWrapper = styled.div`
    position: absolute;
    z-index: 10;
    top: 73px;
    left: 0;
    width: 100%;
`;
export const ListOfTickers = styled(Scrollbars)`
    border-radius: 6px;
    border: 1px solid #629361;
    width: 100%;
    height: fit-content;
    top: 5px;
    display: flex;
    flex-direction: column;
    background-color: white;
`;

export const ListTickerItem = styled.button`
    text-align: left;
    display: block;
    background-color: white;
    width: 100%;
    padding: 8px 17px;
    cursor: pointer;
    border: 1px solid rgba(98, 147, 97, 0.2);
    :hover {
        background: rgba(98, 147, 97, 0.15);
    }
`;

export const StyledDatepicker = styled(DatePicker)`
    width: 100%;
    margin-top: 8px;
    padding: 12px 17px;
    border-radius: 6px;
    font-size: 18px;

    #real_time_date_picker {
        display: none;
    }
`;

export const TimeBlock = styled.div`
    display: flex;
    gap: 12px;
    width: 100%;

    > div {
        width: 50%;
    }
`;

export const StyledTimepicker = styled(TimePicker)`
    margin-top: 8px;
    padding: 12px 17px;
    border-radius: 6px;
    font-size: 18px;
    width: 100%;
`;

export const MaskedPickerContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const TransparentPicker = styled(DatePicker as any)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & input {
    opacity: 0;
    cursor: pointer;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    outline: none;
  }
`;

export const SaveButton = styled(Button)`
    display: flex;
    height: auto;
    margin-top: 30px;
    margin-right: 0;
    margin-left: auto;
    padding: 11px 17px;
    background: ${({ theme }) => theme.color.settingsBackground};
    color: white;
    font-size: 12px;
    border-radius: 10px;

    :hover {
        background: white;
        color: ${({ theme }) => theme.color.settingsBackground};
        border-color: ${({ theme }) => theme.color.settingsBackground};
    }
`;
